import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { EmployerService } from '@/infra/services/employer';

interface DestroyEmployerParams {
	id: string;
	company_id: string;
	organization_id: string;
}

const Service = EmployerService.getInstance();

export const useDestroyEmployer = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: DestroyEmployerParams) => Service.destroy(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_EMPLOYER]);
			queryClient.invalidateQueries([QUERY_KEYS.GET_LIST_EMPLOYER]);
			message.success(I18n.get('Employer destroyed successfully'));
		},
		onError: () => {
			message.error(I18n.get('Error on destroy employer'));
		}
	});
};
